/**
 * Storezone — Progress Store
 *
 * A tiny singleton that tracks active request count outside of React.
 * The GlobalProgressBar subscribes to this store via ProgressContext.
 * The API client calls increment/decrement directly.
 *
 * This pattern avoids circular dependencies between api.ts and React contexts.
 */

type Listener = (count: number) => void

let _count = 0
const _listeners = new Set<Listener>()

function _notify() {
  _listeners.forEach((l) => l(_count))
}

export const progressStore = {
  increment() {
    _count++
    _notify()
  },

  decrement() {
    _count = Math.max(0, _count - 1)
    _notify()
  },

  getCount(): number {
    return _count
  },

  subscribe(listener: Listener): () => void {
    _listeners.add(listener)
    return () => _listeners.delete(listener)
  },
}
